import { render, staticRenderFns } from "./需求项目商品详细_辉县版本.vue?vue&type=template&id=45b6eb54&scoped=true"
import script from "./需求项目商品详细_辉县版本.vue?vue&type=script&lang=js"
export * from "./需求项目商品详细_辉县版本.vue?vue&type=script&lang=js"
import style0 from "./需求项目商品详细_辉县版本.vue?vue&type=style&index=0&id=45b6eb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b6eb54",
  null
  
)

export default component.exports